import { Modal, Button } from 'react-bootstrap';
import '../styles/SessionTimeoutModal.css';

/**
 * Modal that displays when user session is about to expire
 * Allows user to extend session or logout
 */
const SessionTimeoutModal = ({ show, timeRemaining, onExtend, onLogout }) => {
  // Convert seconds to MM:SS format
  const formatTime = (seconds) => {
    if (!seconds) return '0:00';
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <Modal
      show={show}
      centered
      backdrop="static"
      keyboard={false}
      className="session-timeout-modal"
    >
      <Modal.Header className="session-timeout-header">
        <Modal.Title className="session-timeout-title">
          ⏰ Session Expiring Soon
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="session-timeout-body">
        <div className="session-timeout-message">
          <p className="session-text">
            Your session will expire in <strong className="time-remaining">{formatTime(timeRemaining)}</strong>.
          </p>
          <p className="session-subtext">
            Would you like to continue working or logout now?
          </p>
        </div>

        <div className="session-timeout-timer">
          <div className="timer-bar">
            <div
              className="timer-progress"
              style={{
                width: `${Math.max(0, (timeRemaining / 300) * 100)}%` // 300 seconds = 5 minutes
              }}
            />
          </div>
          <p className="timer-label">Time remaining: {formatTime(timeRemaining)}</p>
        </div>
      </Modal.Body>

      <Modal.Footer className="session-timeout-footer">
        <Button
          variant="secondary"
          onClick={onLogout}
          className="logout-btn"
        >
          Logout
        </Button>
        <Button
          variant="primary"
          onClick={onExtend}
          className="continue-btn"
        >
          Continue Working
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionTimeoutModal;
